export default __webpack_public_path__ + "static/media/ia.1257f538.png";